import { render, staticRenderFns } from "./materTransfer_Detail.vue?vue&type=template&id=71ef2220&"
import script from "./materTransfer_Detail.vue?vue&type=script&lang=js&"
export * from "./materTransfer_Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports